import u from "./index54.js";
import m from "./index57.js";
import l from "./index46.js";
import { isString as o } from "./index125.js";
import "./index47.js";
import "./index48.js";
import "./index30.js";
import "./index55.js";
import "./index58.js";
const d = "d{.}`m{.}`Y";
class r extends u {
  static extractPatternOptions(t) {
    const {
      mask: e,
      pattern: s,
      ...n
    } = t;
    return {
      ...n,
      mask: o(e) ? e : s
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(t) {
    super(r.extractPatternOptions({
      ...r.DEFAULTS,
      ...t
    }));
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    const {
      mask: e,
      pattern: s,
      blocks: n,
      ...p
    } = {
      ...r.DEFAULTS,
      ...t
    }, a = Object.assign({}, r.GET_DEFAULT_BLOCKS());
    t.min && (a.Y.from = t.min.getFullYear()), t.max && (a.Y.to = t.max.getFullYear()), t.min && t.max && a.Y.from === a.Y.to && (a.m.from = t.min.getMonth() + 1, a.m.to = t.max.getMonth() + 1, a.m.from === a.m.to && (a.d.from = t.min.getDate(), a.d.to = t.max.getDate())), Object.assign(a, this.blocks, n), super._update({
      ...p,
      mask: o(e) ? e : s,
      blocks: a
    });
  }
  doValidate(t) {
    const e = this.date;
    return super.doValidate(t) && (!this.isComplete || this.isDateExist(this.value) && e != null && (this.min == null || this.min <= e) && (this.max == null || e <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(t) {
    return this.format(this.parse(t, this), this).indexOf(t) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(t) {
    this.typedValue = t;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(t) {
    super.typedValue = t;
  }
  maskEquals(t) {
    return t === Date || super.maskEquals(t);
  }
  optionsIsChanged(t) {
    return super.optionsIsChanged(r.extractPatternOptions(t));
  }
}
r.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: m,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: m,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: m,
    from: 1900,
    to: 9999
  }
});
r.DEFAULTS = {
  ...u.DEFAULTS,
  mask: Date,
  pattern: d,
  format: (i, t) => {
    if (!i)
      return "";
    const e = String(i.getDate()).padStart(2, "0"), s = String(i.getMonth() + 1).padStart(2, "0"), n = i.getFullYear();
    return [e, s, n].join(".");
  },
  parse: (i, t) => {
    const [e, s, n] = i.split(".").map(Number);
    return new Date(n, s - 1, e);
  }
};
l.MaskedDate = r;
export {
  r as default
};
